import React from 'react';
import PropTypes from 'prop-types';

const FlagFireworks = ({ secondary, primary }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      height="80px"
      xmlSpace="preserve"
      role="img"
    >
      <title>Flag Firework</title>
      <g transform="translate(-268.369 -564.512)">
        <path
          fill={secondary}
          id="Path_511"
          className="st0"
          d="M855.76,923.72c-5.67-0.01-10.27-4.61-10.26-10.28c0-2.08,0.64-4.11,1.82-5.82l5.84-8.45
			c3.14-4.72,9.52-6,14.24-2.86c4.72,3.14,6,9.52,2.86,14.24c-0.07,0.1-0.13,0.19-0.2,0.29l-5.83,8.45
			C862.3,922.08,859.14,923.73,855.76,923.72z M890.78,873.01c-5.67-0.01-10.27-4.61-10.26-10.28c0-2.08,0.64-4.11,1.82-5.82
			l5.84-8.45c3.31-4.61,9.72-5.67,14.33-2.36c4.5,3.23,5.63,9.43,2.56,14.04l-5.83,8.44C897.32,871.36,894.15,873.02,890.78,873.01z
			 M925.79,822.29c-5.67-0.01-10.26-4.62-10.25-10.29c0-2.08,0.64-4.1,1.82-5.81l5.83-8.44c3.31-4.61,9.72-5.67,14.33-2.36
			c4.5,3.22,5.63,9.43,2.56,14.04l-5.83,8.44C932.33,820.64,929.17,822.3,925.79,822.29z M960.82,771.59
			c-5.67-0.01-10.27-4.61-10.26-10.28c0-2.08,0.64-4.11,1.82-5.82l5.83-8.46c3.23-4.67,9.62-5.84,14.29-2.61
			c4.67,3.23,5.84,9.62,2.61,14.29l-5.84,8.45C967.36,769.93,964.19,771.59,960.82,771.59z"
        />
        <path
          fill={secondary}
          id="Path_512"
          className="st0"
          d="M588.03,937.63c-3.4,0.01-6.59-1.68-8.51-4.49l-5.78-8.51c-3.19-4.69-1.97-11.09,2.72-14.28
			c4.69-3.19,11.09-1.97,14.28,2.72l0,0l5.77,8.51c3.19,4.69,1.97,11.08-2.72,14.27C592.09,937.01,590.09,937.63,588.03,937.63
			L588.03,937.63z M553.37,886.66c-3.4,0.01-6.59-1.68-8.51-4.49l-5.77-8.5c-3.19-4.69-1.97-11.08,2.72-14.27
			c4.69-3.19,11.08-1.97,14.27,2.72l0,0l5.77,8.5c3.19,4.69,1.97,11.08-2.72,14.27C557.44,886.04,555.43,886.66,553.37,886.66z
			 M518.72,835.71c-3.4,0.01-6.59-1.68-8.51-4.49l-5.77-8.5c-3.19-4.69-1.97-11.08,2.72-14.27c4.69-3.19,11.08-1.97,14.27,2.72
			l5.78,8.5c3.19,4.69,1.97,11.08-2.72,14.27C522.79,835.09,520.78,835.71,518.72,835.71L518.72,835.71z M484.06,784.74
			c-3.4,0.01-6.59-1.68-8.51-4.49l-5.77-8.5c-3.19-4.69-1.97-11.08,2.72-14.27c4.69-3.19,11.08-1.97,14.27,2.72l5.78,8.5
			c3.19,4.69,1.97,11.08-2.72,14.27c-1.7,1.16-3.71,1.78-5.76,1.78L484.06,784.74z"
        />

        <path
          fill={secondary}
          id="Path_513"
          className="st0"
          d="M469.91,1158.48c-0.69,0-1.38-0.06-2.05-0.21l-10.08-2.05c-5.56-1.13-9.15-6.55-8.02-12.11
			c1.13-5.54,6.51-9.13,12.06-8.03l10.07,2.05c5.57,1.1,9.19,6.5,8.09,12.07C479.01,1155,474.8,1158.47,469.91,1158.48z
			 M409.48,1146.39c-0.69,0-1.38-0.06-2.05-0.19l-10.08-2.05c-5.56-1.13-9.15-6.55-8.02-12.11c1.13-5.54,6.51-9.13,12.06-8.03
			l10.08,2.05c5.56,1.13,9.15,6.55,8.02,12.11c-0.97,4.77-5.16,8.21-10.02,8.23H409.48z M349.04,1134.3
			c-0.69,0.01-1.38-0.06-2.05-0.2l-10.08-2.05c-5.56-1.13-9.15-6.55-8.02-12.11c1.13-5.54,6.51-9.13,12.06-8.03l10.07,2.05
			c5.56,1.13,9.15,6.55,8.02,12.11c-0.97,4.77-5.16,8.21-10.02,8.23H349.04z M288.61,1122.22c-0.69,0-1.38-0.07-2.05-0.21
			l-10.07-2.05c-5.55-1.19-9.08-6.65-7.89-12.2c1.17-5.43,6.45-8.95,11.91-7.94l10.08,2.05c5.57,1.1,9.19,6.5,8.09,12.07
			c-0.95,4.82-5.18,8.29-10.09,8.28H288.61z"
        />

        <path
          fill={secondary}
          id="Path_514"
          className="st0"
          d="M1075.95,1096.85c-5.67,0.01-10.28-4.59-10.28-10.26c0-4.25,2.61-8.07,6.57-9.59l9.57-3.71
			c5.29-2.05,11.24,0.57,13.29,5.87c2.05,5.29-0.58,11.24-5.87,13.29l-9.58,3.72C1078.47,1096.62,1077.21,1096.85,1075.95,1096.85z
			 M1133.47,1074.6c-5.67,0.01-10.28-4.59-10.28-10.26c0-4.25,2.61-8.07,6.57-9.59l9.58-3.71c5.31-1.99,11.23,0.71,13.22,6.03
			c1.95,5.23-0.62,11.06-5.8,13.13l-9.57,3.72C1136,1074.37,1134.74,1074.6,1133.47,1074.6z M1190.99,1052.35
			c-5.67,0.01-10.28-4.59-10.28-10.26c0-4.25,2.61-8.07,6.57-9.59l9.57-3.71c5.29-2.05,11.24,0.57,13.29,5.86
			c2.05,5.29-0.58,11.24-5.87,13.29l-9.58,3.72c-1.21,0.46-2.5,0.7-3.8,0.69L1190.99,1052.35z M1248.51,1030.1
			c-5.67,0.01-10.28-4.59-10.28-10.26c0-4.25,2.61-8.07,6.57-9.59l9.57-3.71c5.29-2.05,11.24,0.57,13.29,5.87
			c2.05,5.29-0.58,11.24-5.87,13.29l-9.58,3.72c-1.23,0.46-2.54,0.69-3.85,0.67L1248.51,1030.1z"
        />
      </g>
      <g transform="translate(-268.369 -564.512)">
        <path
          fill={primary}
          d="M822.97,1095.69c-10.31-5.15-18.65-13.52-23.75-23.85c-7.14-13.19-17.97-24-31.18-31.1
			c-31.57-14.19-68.11,3.89-94.8,17.1c-3.08,1.54-6.16,3.03-9,4.41c-8.53,4.84-17.88,8.05-27.58,9.48l-10.92-40.06
			c-1.68-5.86-7.79-9.26-13.65-7.58c-5.76,1.65-9.16,7.59-7.65,13.4l46.22,169.67l3.72,14.63l0.77,1.8l42.22,154.73
			c1.31,4.8,5.67,8.14,10.65,8.15c0.99,0,1.97-0.13,2.92-0.39c5.88-1.61,9.35-7.68,7.74-13.56l-38.01-139.15
			c26.99-18.61,71.05-44.05,91.67-44.05h1.35c5.07,0.3,5.6,0.91,8.03,9.42c6.39,22.33,18.98,33.7,61.99,21.47
			c72.98-20.78,107.44-118.08,108.88-122.24l7.33-21.18l-21.26,7.09C914.68,1091.93,852.21,1106.01,822.97,1095.69z M671.71,1197.33
			c-0.19,0.2-0.37,0.4-0.53,0.62l-23.93-94.27c29.52,7.25,47.57,37.05,40.33,66.57C685.02,1180.62,679.51,1190.03,671.71,1197.33z"
        />
      </g>
    </svg>
  );
};

export default FlagFireworks;

FlagFireworks.propTypes = {
  secondary: PropTypes.string.isRequired,
  primary: PropTypes.string.isRequired,
};
